import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Music2 } from "lucide-react";
import { AppHeader } from "@/components/AppHeader";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function Dashboard() {
  const navigate = useNavigate();
  const { user, refresh } = useAuth();
  const [acking, setAcking] = useState(false);
  const showFreeHint =
    user?.status === "verified" && !user?.first_order_used && !user?.free_hint_acknowledged;

  const acknowledge = async () => {
    setAcking(true);
    try {
      await api.post("/me/acknowledge-free-hint");
      await refresh();
    } catch (e) {
      // still hide on client; will re-sync on next load
      await refresh();
    } finally {
      setAcking(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex flex-col" data-testid="dashboard-page">
      <AppHeader />
      <main className="flex-1 flex items-center justify-center px-5 sm:px-6 py-16 sm:py-24">
        <div className="text-center max-w-2xl w-full cd-fade-in">
          <span className="inline-flex w-14 h-14 sm:w-16 sm:h-16 rounded-full border border-sand items-center justify-center bg-white mb-6 sm:mb-8">
            <Music2 className="w-6 h-6 sm:w-7 sm:h-7 text-gold" strokeWidth={1.5} />
          </span>
          <h1 className="font-serif text-3xl sm:text-5xl font-light text-charcoal leading-tight">
            Willkommen bei Canto Dei
          </h1>

          {showFreeHint && (
            <div className="mt-8 bg-gold/10 border border-gold/30 rounded-sm p-5 sm:p-6" data-testid="dashboard-free-hint">
              <p className="text-base text-gold leading-relaxed">
                Ihr erster individueller personalisierter Trauersong ist kostenlos.
              </p>
              <Button
                onClick={acknowledge}
                disabled={acking}
                variant="outline"
                size="sm"
                className="mt-4 border-gold text-gold hover:bg-gold hover:text-white rounded-sm transition-colors duration-500"
                data-testid="free-hint-ack-button"
              >
                {acking ? "…" : "Verstanden"}
              </Button>
            </div>
          )}

          <div className="mt-6 bg-white border border-sand rounded-sm p-6 sm:p-8 text-left space-y-3" data-testid="dashboard-info">
            <p className="text-base text-charcoal/80 leading-relaxed">
              Ihr Einkaufspreis beträgt 99 CHF pro individuellem personalisiertem Trauersong.
            </p>
            <p className="text-sm text-charcoal/70 leading-relaxed">
              Den Verkaufspreis gegenüber Ihren Kunden bestimmen Sie selbst. Wir empfehlen
              einen Verkaufspreis zwischen 149 CHF und 199 CHF.
            </p>
          </div>

          <Button
            onClick={() => navigate("/trauersong-erstellen")}
            className="mt-10 w-full sm:w-auto bg-gold hover:bg-golddark text-white rounded-sm px-8 sm:px-10 py-6 sm:py-7 text-sm sm:text-base transition-colors duration-500"
            data-testid="create-song-button"
          >
            Individuellen personalisierten Trauersong erstellen
          </Button>
        </div>
      </main>
    </div>
  );
}
